import Dispatcher from './Dispatcher';
import ActionTypes from './ActionTypes';
import checkStatus from '../utils/checkStatus';
import api from '../utils/api';
import dispatchHttpError from '../utils/dispatchHttpError';
import JwtStore from "./JwtStore";

export default {
  fetch() {
    return fetch(api('user'), {
      headers: {
        'Authorization': `Bearer ${JwtStore.getToken()}`,
        'Accept': 'application/json'
      },
    })
      .then(checkStatus)
      .then(response => response.json())
      .then(response => Dispatcher.dispatch({
        actionType: ActionTypes.USER_STORE_FETCH_COMPLETED,
        user: response.data,
      }))
      .catch(dispatchHttpError);
  },

  updateLanguage(language) {
    return fetch(api('user'), {
      method: 'PATCH',
      headers: {
        'Authorization': `Bearer ${JwtStore.getToken()}`,
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        language,
      })
    })
      .then(checkStatus)
      .then(response => response.json())
      .then(response => Dispatcher.dispatch({
        actionType: ActionTypes.USER_STORE_UPDATE_LANGUAGE_COMPLETED,
        user: response.data,
      }))
      .catch(dispatchHttpError);
  },
}
